var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 13.9998C5.04167 13.9998 4.64931 13.8366 4.32292 13.5103C3.99653 13.1839 3.83333 12.7915 3.83333 12.3332V2.33317C3.83333 1.87484 3.99653 1.48248 4.32292 1.15609C4.64931 0.829698 5.04167 0.666504 5.5 0.666504H13C13.4583 0.666504 13.8507 0.829698 14.1771 1.15609C14.5035 1.48248 14.6667 1.87484 14.6667 2.33317V12.3332C14.6667 12.7915 14.5035 13.1839 14.1771 13.5103C13.8507 13.8366 13.4583 13.9998 13 13.9998H5.5ZM5.5 12.3332H13V2.33317H5.5V12.3332ZM2.16667 17.3332C1.70833 17.3332 1.31597 17.17 0.989583 16.8436C0.663194 16.5172 0.5 16.1248 0.5 15.6665V3.99984H2.16667V15.6665H11.3333V17.3332H2.16667Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.a4af071f7760d7419c27e8322b3d1f99.svg";
export { ForwardRef as ReactComponent };